import { Record } from "immutable"

const TrashedItem = Record({
  type: "",
  entity: {}
})

export default TrashedItem
